import api from "@/utils/api.js";

/**
 * Get coverage report for a date range
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @param {boolean} includeMissing - Include missing combinations per day
 * @returns {Promise} - Coverage report data
 */
export const getCoverageReport = async (startDate, endDate, includeMissing = false) => {
  try {
    const response = await api.accountingApi.get("/api/accounting/sales/coverage", {
      params: {
        start_date: startDate,
        end_date: endDate,
        include_missing: includeMissing ? "true" : "false",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching coverage report:", error);
    throw error;
  }
};

export default {
  getCoverageReport,
};
